import "./App.css";
import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Layout, Menu } from "antd";
import Navbar from "./components/navbar/Navbar";
import Home from "./components/pages/home/Home";
import MenuPage from "./components/pages/menu/Menu";
import ScrollToTop from "./components/ScrollToTop";
function App() {
  const contactSectionRef = useRef(null);

  // Function to scroll to the contact section
  const scrollToContact = () => {
    contactSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Layout style={{ backgroundColor: "#f2eae9" }}>
          <Navbar scrollToContact={scrollToContact} />
          <Layout.Content style={{ marginTop: "110px" }}>
            <Routes>
              <Route
                path="/"
                element={<Home contactSectionRef={contactSectionRef} />}
              />
              <Route path="/menu" element={<MenuPage />} />
            </Routes>
          </Layout.Content>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
